<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Qqx3rV/tc-custom/9780062292742.jpg?1732245285830" alt="This image is the cover for the book Pope Francis"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pope Francis
      </h1>
      <p class="bookDescription body article font2">
        <p>On March 13, the cardinals of the Catholic Church, gathered to elect a successor to a living Pope for the first time in 600 years, announced a dramatic shift. By elevating Cardinal Jorge Mario Bergoglio of Argentina to become Pope Francis the 266th Pontiff, the cardinals were naming the first-ever Pope from the growing New World to take the helm of the church at a crucial moment.</p><p>It was a stunning move by a 2,000-year-old institution that has immense influence—with 1.2 billion adherents worldwide—and huge problems, including a decade-old sex-abuse scandal that has shattered faith in the institution, a shortage of priests and secular trends that have drained the church of members and challenged its relevancy in a changing world.</p><p>From the shocking decision by Pope Benedict XVI to retire, to the introduction of Pope Francis, from the back streets of Buenos Aires to the front row at St. Peter's Square, reporters from <i>The Wall Street Journal</i> have chronicled these dramatic weeks in the life of the oldest institution in the world. Now, in a new e-book, Journal reporters will present a detailed, timely and original biography of the new Pope Francis, as well as new insight on the bargaining and drama that surrounded his rise. Pope Francis will present the full, in-depth story of the church's change in direction and the man charged with leading it, and consider how Pope Francis might address the years of scandal and shortcomings while leading Catholics worldwide toward a deeper faith.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        The Staff of the Wall Street Journal
      </h2>
      
      <p class="authorDescription body article"><P>The Wall Street Journal is America's largest newspaper by total average circulation with nearly 2.3 million subscribers and 36 million global digital visitors per month. In recent years, the Journal has expanded its core content offering to include coverage of the arts, culture, lifestyle, sports, and health, building on its heritage as the leading source of business and financial news. As one of the world's largest news gathering operations with 2,000 journalists in more than 50 countries, the Journal franchise now spans eight editions in 11 languages, engaging readers across newspapers, websites, magazines, social media, and videos. The Journal holds 34 Pulitzer Prizes for outstanding journalism.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1badc061